export const extractEntryContentType = (entry) => entry?.sys?.contentType?.sys.id;
